/**
 * AMK Variant Sync
 * Ensures the correct variant ID is set in the product form's hidden input
 * when a variant is selected via radio buttons or dropdowns.
 */

/**
 * Sync the selected variant ID to the product form's hidden input.
 * @param {HTMLElement} picker - The variant picker element.
 * @param {string} variantId - The selected variant ID.
 */
function syncVariantId(picker, variantId) {
  if (!variantId) return;

  const sectionId = picker.getAttribute('data-section-id');
  const container = sectionId
    ? document.querySelector(`[data-section-id="${sectionId}"]`)
    : null;

  const productForm =
    container?.querySelector('product-form-component') ||
    document.querySelector('product-form-component');

  if (!productForm) return;

  const idInput = productForm.querySelector('input[name="id"]');
  if (!idInput) return;

  idInput.value = variantId;
}

/**
 * Initialize variant sync for all variant pickers on the page.
 */
function initVariantSync() {
  document.querySelectorAll('.variant-picker').forEach((picker) => {
    // Radio buttons (button-style variants)
    picker.querySelectorAll('input[type="radio"][data-variant-id]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        syncVariantId(picker, radio.getAttribute('data-variant-id'));
      });
    });

    // Dropdown variants
    picker.querySelectorAll('select.variant-option__select').forEach((select) => {
      select.addEventListener('change', () => {
        const option = select.selectedOptions?.[0];
        if (!option) return;
        syncVariantId(picker, option.getAttribute('data-variant-id'));
      });
    });

    // Initial sync: set the currently selected variant on load
    const checked = picker.querySelector('input[type="radio"][data-variant-id]:checked');
    if (checked) {
      syncVariantId(picker, checked.getAttribute('data-variant-id'));
    } else {
      const firstSelect = picker.querySelector('select.variant-option__select');
      if (firstSelect?.selectedOptions.length) {
        const id = firstSelect.selectedOptions[0].getAttribute('data-variant-id');
        if (id) syncVariantId(picker, id);
      }
    }
  });
}

// ES6 modules are deferred by default
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantSync, { once: true });
} else {
  initVariantSync();
}
